import PageIntro from "@/components/PageIntro";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  { q: "Is joining the community free?", a: "Yes. Joining Rituals With You is free. Individual programme costs, shipping terms and eligibility are configured and clearly disclosed before an application opens." },
  { q: "Does membership guarantee a product?", a: "No. Membership does not guarantee a product. Selection depends on programme eligibility and availability." },
  { q: "How do experience programmes work?", a: "When a programme opens, you choose the product, answer a few short questions and submit an application. Selected members accept an invitation before providing shipping details. Selection is never the same as shipment." },
  { q: "Is my feedback private?", a: "Yes. Your private feedback and any photos are private by default. Sharing a public story is a separate, voluntary action with explicit permission and an exact preview of what will be visible." },
  { q: "Can I share critical experiences?", a: "Yes. We welcome honest feedback, positive and critical. Moderation addresses privacy, abuse, relevance and unsafe claims—not sentiment." },
  { q: "Can I leave or delete my data?", a: "Yes. You can manage your permissions, withdraw from participation and request data export or deletion from My Rituals." },
];

export default function Faq() {
  return (
    <div>
      <PageIntro eyebrow="Good to know" title="Frequently asked questions" />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <Accordion type="single" collapsible>
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-forest/15">
              <AccordionTrigger className="text-left font-serif text-xl text-forest hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-charcoal/75 text-base leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
}
